import React from 'react';

interface PageHeroProps {
  title: string;
  subtitle?: string;
  gradientColors?: {
    from: string;
    via?: string;
    to: string;
  };
  titleGradient?: {
    from: string;
    to: string;
  };
  subtitleColor?: string;
  animatedElements?: boolean;
}

const PageHero: React.FC<PageHeroProps> = ({
  title,
  subtitle,
  gradientColors = {
    from: 'from-blue-600',
    via: 'via-purple-600',
    to: 'to-green-600'
  },
  titleGradient = {
    from: 'from-white',
    to: 'to-blue-100'
  },
  subtitleColor = 'text-blue-100',
  animatedElements = true
}) => {
  return (
    <div className={`relative bg-gradient-to-r ${gradientColors.from} ${gradientColors.via} ${gradientColors.to} text-white py-20 px-4 overflow-hidden`}>
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative container mx-auto text-center z-10">
        <h1 className={`text-5xl md:text-7xl font-bold mb-6 bg-gradient-to-r ${titleGradient.from} ${titleGradient.to} bg-clip-text text-transparent`}>
          {title}
        </h1>
        {subtitle && (
          <p className={`text-xl md:text-2xl ${subtitleColor} max-w-3xl mx-auto`}>
            {subtitle}
          </p>
        )}
      </div>
      
      {/* Animated background elements */}
      {animatedElements && (
        <>
          <div className="absolute top-10 left-10 w-20 h-20 bg-white/10 rounded-full animate-bounce"></div>
          <div className="absolute bottom-10 right-10 w-32 h-32 bg-white/10 rounded-full animate-pulse"></div>
          <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-white/10 rounded-full animate-ping"></div>
        </>
      )}
    </div>
  );
};

export default PageHero; 